import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const ParentDataContext = createContext(null);

export const ParentDataProvider = ({ children }) => {
  const [childrenList, setChildrenList] = useState(null);
  const [pendingLinkRequests, setPendingLinkRequests] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const refreshChildren = useCallback(async () => {
    try {
      const [childrenRes, requestsRes] = await Promise.all([
        axios.get(`${API}/parent/me/children`, auth()),
        axios.get(`${API}/parent/me/link-requests`, auth()),
      ]);
      setChildrenList(childrenRes.data || []);
      setPendingLinkRequests((requestsRes.data || []).filter((r) => r.status === 'pending'));
    } catch { setChildrenList([]); }
  }, []);

  const refreshUnreadCount = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/parent/me/notifications/unread-count`, auth());
      setUnreadCount(res.data?.count || 0);
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    refreshChildren();
    refreshUnreadCount();
    const interval = setInterval(refreshUnreadCount, 60000);
    return () => clearInterval(interval);
  }, [refreshChildren, refreshUnreadCount]);

  return (
    <ParentDataContext.Provider value={{ childrenList, pendingLinkRequests, unreadCount, refreshChildren, refreshUnreadCount }}>
      {children}
    </ParentDataContext.Provider>
  );
};

export const useParentData = () => useContext(ParentDataContext);
